import mainLayout from "./mainLayout";
import AuthLayout from "./authLayout";
const layouts={
     mainLayout,
     AuthLayout
}
export default layouts